module.exports = __webpack_public_path__ + "img/132.0cb67576.png";